import React from 'react';
import {Typography,Grid} from '@material-ui/core';
import {isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';

function Avtal(props) {
    return (
        <>
        {
            isUndefined(props.Avtal)?""
            :
<Grid container className="px-5">
            <Grid md="12">
            <h2><IntlMessages id="Agreement"/></h2>
            </Grid>      
            <Grid md="2"><Typography>Rubrik:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Avtal.Rubrik}</Typography></Grid>          
            <Grid md="2"><Typography>Värde:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Avtal.Varde}</Typography></Grid>          
            <Grid md="2"><Typography><IntlMessages id="Agreement.Type"/>:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Avtal.avtaltyp}</Typography></Grid>          
            <Grid md="2"><Typography>Leverantör:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Avtal.Leverantor}</Typography></Grid>          
            <Grid md="2"><Typography><IntlMessages id="Input.onGoing"/></Typography></Grid>      
            <Grid md="10"><Typography>{(props.Avtal.Laperut === 1)?<IntlMessages id="Option.Yes"/>:<IntlMessages id="Option.No"/>}</Typography></Grid>
            {
                (props.Avtal.Laperut === 1)?"":
                <>
            <Grid md="2"><Typography>Slutdatum:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Avtal.Slutdatum}</Typography></Grid>
            <Grid md="2"><Typography>Omförhandling:</Typography></Grid>      
            <Grid md="4"><Typography>{props.Avtal.Omforhandle}</Typography></Grid>
                </>
            }          
        </Grid>
        }
        
        </>
    );
}

export default Avtal;